
window.addEventListener('click', function (e) {
    if (document.querySelector('.header__search').contains(e.target)) {
        document.querySelector('.header__search-form').classList.add('open');
        document.querySelector('.header__search-text').focus();
    } else {
        document.querySelector('.header__search-form').classList.remove('open');
    }
});


function scrollToTop(duration) {
    const cosParameter = window.scrollY / 2
    let scrollCount = 0
    let oldTimestamp = performance.now()

    function step(newTimestamp) {
        scrollCount += Math.PI / (duration / (newTimestamp - oldTimestamp))
        if (scrollCount >= Math.PI) {
            window.scrollTo(0, 0)
        }
        if (window.scrollY === 0) {
            return
        }
        window.scrollTo(0, Math.round(cosParameter + cosParameter * Math.cos(scrollCount)))
        oldTimestamp = newTimestamp
        window.requestAnimationFrame(step)
    }

    window.requestAnimationFrame(step)
}

function onScroll() {
    let hasScrolled = true
    window.onscroll = function (e) {
        if (hasScrolled) {
            hasScrolled = false
            const element = document.getElementById('up')
            const fixMenu = document.getElementById('header_js')
            if (window.pageYOffset > 57) {
                fixMenu.classList.add('fixed');
            } else {
                fixMenu.classList.remove('fixed');
            }
            if (window.pageYOffset > 600) {
                element.classList.add('on');
            } else {
                element.classList.remove('on')
            }
            setTimeout(() => {
                hasScrolled = true
            }, 25)
        }
    }
}


document.addEventListener('DOMContentLoaded', () => {
    const btnToggleCategory = document.getElementById('btnToggleCategory')
    const categoriesBlock = document.getElementById('categoriesBlock')
    if (btnToggleCategory) {
        btnToggleCategory.addEventListener('click', () => {
            categoriesBlock.classList.toggle('on')
        })
    }

    const postContent = document.querySelector('.post__content')
    if (postContent) {
        const images = postContent.querySelectorAll('img');
        images.forEach(image => {
            // Проверяем, находится ли изображение внутри блока, который мы хотим игнорировать
            if (!image.closest('#info-block-m')) {
                const parent = image.parentNode;
                const wrapper = document.createElement('a');
                wrapper.classList.add('content-img-wrapper');
                wrapper.setAttribute('href', image.getAttribute('src'));
                wrapper.setAttribute('data-fslightbox', 'gallery');
                parent.replaceChild(wrapper, image);
                wrapper.appendChild(image);
                if (image.getAttribute('caption')) {
                    const caption = document.createElement('figcaption');
                    caption.classList.add('content-img-caption');
                    caption.innerHTML = image.getAttribute('caption');
                    wrapper.appendChild(caption);
                }
            }
        });
        refreshFsLightbox();
    }
    // if (postContent) {
    //     const images = postContent.querySelectorAll('img')
    //     images.forEach(image => {
    //         const parent = image.parentNode
    //         const wrapper = document.createElement('a')
    //         wrapper.classList.add('content-img-wrapper')
    //         wrapper.setAttribute('href', image.getAttribute('src'))
    //         wrapper.setAttribute('data-fslightbox', 'gallery')
    //         parent.replaceChild(wrapper, image)
    //         wrapper.appendChild(image)
    //         if (image.getAttribute('caption')) {
    //             const caption = document.createElement('figcaption')
    //             caption.classList.add('content-img-caption')
    //             caption.innerHTML = image.getAttribute('caption')
    //             wrapper.appendChild(caption)
    //         }
    //     })
    //     refreshFsLightbox();
    // }

    const dialogsClose = document.querySelectorAll('.dialog-close')
    dialogsClose.forEach(button => {
        button.addEventListener('click', () => {
            const wrapper = button.closest('.dialog__wrapper')
            const bg = button.closest('.dialog__bg')
            const dialog = button.closest('.dialog__container')
            dialog.classList.add('dialog__container_off')
            bg.classList.add('dialog__bg_off')
            setTimeout(() => {
                wrapper.classList.add('dialog__wrapper_off')
            }, 150)
        })
    })

    function onDialog(element) {
        const bg = element.querySelector('.dialog__bg')
        const dialog = element.querySelector('.dialog__container')
        element.classList.remove('dialog__wrapper_off')
        setTimeout(() => {
            dialog.classList.remove('dialog__container_off')
            bg.classList.remove('dialog__bg_off')
        }, 150)
    }

    const dialogLocation = document.getElementById('dialogLocation')
    const dialogLocationOn = document.getElementById('dialogLocationOn')
    if (dialogLocation && dialogLocationOn) {
        dialogLocationOn.addEventListener('click', () => {
            onDialog(dialogLocation)
        })
    }

    element = document.getElementById('up')
    element.onclick = (e) => {
        e.preventDefault()
        scrollToTop(500)
    }
    onScroll()

    shareButton = document.getElementById('shareButton')
    if (shareButton) {
        shareButton.addEventListener('click', function () {
            if (navigator.share) {
                const description = document.head.querySelector('meta[name="description"]').getAttribute('content')
                navigator.share({
                    title: document.title,
                    text: description ? description : '',
                    url: window.location.href
                })
            }
        })
    }

    payButton = document.getElementById('payButton')
    if (payButton) {
        payButton.addEventListener('click', () => {
            const element = document.getElementById('scheduleRambler')
            const rect = element.getBoundingClientRect()
            window.scrollTo({
                top: (rect.top + window.scrollY) - 100,
                behavior: 'smooth'
            })
        })
    }

    function isElementVisible(element, percentVisible = 80) {
        const rect = element.getBoundingClientRect(),
            windowHeight = (window.innerHeight || document.documentElement.clientHeight)
        if (getComputedStyle(element, null).display === 'none') return false
        return !(
            Math.floor(100 - (((rect.top >= 0 ? 0 : rect.top) / +-rect.height) * 100)) < percentVisible ||
            Math.floor(100 - ((rect.bottom - windowHeight) / rect.height) * 100) < percentVisible
        )
    }

    function counting(element, view = true) {
        const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        fetch(view ? '/counting/v' : '/counting/c', {
            method: 'POST',
            mode: 'same-origin',
            credentials: 'same-origin',
            cache: 'no-cache',
            referrerPolicy: 'no-referrer',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': token
            },
            body: JSON.stringify({
                id: parseInt(element.dataset.id),
                target: element.dataset.target
            })
        })
        element.classList.remove('on')
    }

    links = document.querySelectorAll('.b-link')
    links.forEach(element => {
        element.addEventListener('click', function () {
            counting(element.firstElementChild, false)
        })
    })
    const intval = setInterval(() => {
        bs = document.querySelectorAll('.b-img.on')
        if (bs.length === 0) clearTimeout(intval)
        bs.forEach(element => {
            if (isElementVisible(element)) {
                counting(element)
            }
        })
    }, 1000)

    const tabs = document.querySelectorAll('.tab-list')
    const content = document.querySelectorAll('.tabs-content');
    if (tabs) {
        tabs.forEach((element, i) => element.addEventListener('click', ({target}) => {
            let active = element.querySelector('.active');
            active.classList.remove('active');
            content[i].querySelector('.active').classList.remove('active');
            let index = [...element.querySelectorAll('li')].indexOf(target);
            target.classList.add('active');
            content[i].children[index].classList.add('active');
            let link = target.dataset.href;
            target.closest(".block_head").querySelector('.open-link').href = link;
        }))
    }
})

